var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "currentColor"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.574 9.267a1.316 1.316 0 0 1-1.287 1.326 1.346 1.346 0 0 1-1.297-1.326A1.326 1.326 0 0 1 12.287 8a1.316 1.316 0 0 1 1.287 1.267m-2.445 3.682c0-.762.485-.643 1.158-.643s1.148-.119 1.148.643v7.424c0 .772-.485.614-1.148.614s-1.158.158-1.158-.614zM15.435 12.95c0-.426.158-.585.405-.634s1.1 0 1.396 0c.297 0 .416.485.406.851a2.48 2.48 0 0 1 2.217-.99 2.97 2.97 0 0 1 3.148 3.098v5.068c0 .772-.475.614-1.149.614-.673 0-1.148.158-1.148-.614v-3.959a1.426 1.426 0 0 0-1.504-1.544 1.436 1.436 0 0 0-1.465 1.574v3.959c0 .772-.485.614-1.158.614s-1.148.158-1.148-.614z"
})));
export default SvgIconLinkedin;